module.exports = __webpack_public_path__ + "img/41_36.52b5dd50.png";